/* ============================================================
   OCHSENBRATEREI × MK LEDERMANUFAKTUR — main.js
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {

  /* ----------------------------------------------------------
     HEADER — scroll shadow only (always cream)
  ---------------------------------------------------------- */
  const header = document.getElementById('header');
  window.addEventListener('scroll', () => {
    header.classList.toggle('scrolled', window.scrollY > 10);
  }, { passive: true });

  /* ----------------------------------------------------------
     MOBILE MENU
  ---------------------------------------------------------- */
  const burgerBtn = document.getElementById('burger-btn');
  const mobileMenu = document.getElementById('mobile-menu');
  const burgerIcon = document.getElementById('burger-icon');
  const closeIcon  = document.getElementById('close-icon');

  burgerBtn.addEventListener('click', () => {
    const open = mobileMenu.classList.toggle('open');
    burgerIcon.style.display = open ? 'none'  : 'block';
    closeIcon.style.display  = open ? 'block' : 'none';
  });
  mobileMenu.querySelectorAll('a').forEach(a => {
    a.addEventListener('click', () => {
      mobileMenu.classList.remove('open');
      burgerIcon.style.display = 'block';
      closeIcon.style.display  = 'none';
    });
  });

  /* ----------------------------------------------------------
     IMAGE COMPARISON SLIDER (Patina)
  ---------------------------------------------------------- */
  const cmp    = document.getElementById('comparison');
  const before = document.getElementById('cmp-before');
  const handle = document.getElementById('cmp-handle');

  if (cmp && before && handle) {
    let dragging = false;

    function setPos(clientX) {
      const rect = cmp.getBoundingClientRect();
      let p = (clientX - rect.left) / rect.width;
      p = Math.max(0.04, Math.min(0.96, p));
      const pct = p * 100;
      before.style.clipPath = `inset(0 ${(100 - pct).toFixed(2)}% 0 0)`;
      handle.style.left = `${pct.toFixed(2)}%`;
    }

    // Init at 50%
    function initPos() {
      const rect = cmp.getBoundingClientRect();
      setPos(rect.left + rect.width * 0.5);
    }
    initPos();
    window.addEventListener('resize', initPos);

    cmp.addEventListener('mousedown',  e => { dragging = true; setPos(e.clientX); e.preventDefault(); });
    window.addEventListener('mousemove', e => { if (dragging) setPos(e.clientX); });
    window.addEventListener('mouseup',   () => { dragging = false; });

    cmp.addEventListener('touchstart', e => { dragging = true; setPos(e.touches[0].clientX); }, { passive: true });
    window.addEventListener('touchmove', e => { if (dragging) setPos(e.touches[0].clientX); }, { passive: true });
    window.addEventListener('touchend',  () => { dragging = false; });
  }

  /* ----------------------------------------------------------
     SCROLL REVEAL
  ---------------------------------------------------------- */
  const revealEls = document.querySelectorAll('.reveal');
  const revealObs = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in');
        revealObs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
  revealEls.forEach(el => revealObs.observe(el));

  /* ----------------------------------------------------------
     SMOOTH ANCHOR SCROLL (offset for fixed header)
  ---------------------------------------------------------- */
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const target = document.querySelector(a.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      const offset = 72;
      const top = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  });

});
